import React, { useState } from "react";
import { Box, TextField, IconButton, Popover } from "@mui/material";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import EditDatePicker from "@/modules/common/components/ui/date-picker/edit-date-picker";

interface DatePickerProps {
  value: Date | string | null;
  onChange: (date: string | Date | null) => void;
  label: string;
  maxDate?: Date;
  minDate?: Date;
  error?: any;
  helperText?: string;
}

const DatePickerInput: React.FC<DatePickerProps> = ({
  value,
  onChange,
  label,
  maxDate,
  error,
  helperText,
  minDate,
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClear = (event: React.MouseEvent) => {
    event.stopPropagation();
    onChange(null);
  };

  const open = Boolean(anchorEl);

  return (
    <Box sx={{ width: "100%" }}>
      <TextField
        value={
          value && typeof value !== "string" ? value?.toLocaleDateString() : ""
        }
        fullWidth
        error={!!error}
        helperText={helperText}
        onClick={handleClick}
        label={label}
        InputProps={{
          endAdornment: (
            <>
              {value && (
                <IconButton
                  type="button"
                  aria-label="clear-value"
                  onClick={handleClear}
                >
                  <CloseOutlinedIcon />
                </IconButton>
              )}
              <IconButton
                type="button"
                aria-label="open-calendar"
                onClick={handleClick}
              >
                <CalendarMonthOutlinedIcon />
              </IconButton>
            </>
          ),
        }}
      />
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <EditDatePicker
          date={value}
          setDate={(newDate: string | Date | null) => {
            onChange(newDate);
            handleClose();
          }}
          label={label}
          maxDate={maxDate}
          minDate={minDate}
        />
      </Popover>
    </Box>
  );
};

export default DatePickerInput;
